
export enum CodeCoursMarche {
  PARITE_EUR_USD = 'PARITE_EUR_USD',
  PETROLE_WTI = 'PETROLE_WTI',
  GAZ_NATUREL = 'GAZ_NATUREL'
}
